import {
  call, put, delay, select,
} from 'redux-saga/effects';
import moment from 'moment/moment';
import processError from '../../../utils/processError';
import {
  addProgressLog, setLogList, setProgressList, showProgressBar, stoppedProgressBar,
} from '../../System/actions';
import {
  importVehiclesSuccessful, importVehiclesFailed, loadStatusImport,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, LOADING_DELAY } from '../../../configs';
import { dateTimeStringFormatter } from '../../../utils/formatters';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

export default function* importVehicles(action) {
  try {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    };
    const pool = action.payload;
    const url = `${BACKEND_URL}/registries/vehicles/import`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true, headers, true);
    yield put(showProgressBar({
      title: 'Импорт рестровых записей',
      text: 'group.import.file',
    }));
    const data = yield dataResponse.json();

    if (dataResponse.status === CREATED) {
      let stopImport = false;
      while (!stopImport) {
        stopImport = yield select(getStop);
        const registryLoadPromise = yield put(loadStatusImport({ id: data.data.id }));
        const { data: registry } = yield registryLoadPromise;

        yield put(setProgressList({
          progressCount: registry?.total_rows,
          progressPercent: registry?.progress,
          progressCountSuccess: registry?.processed_rows,
        }));
        yield put(setLogList({ log: renderLog(registry) }));
        if (registry?.status === 3) {
          yield put(stoppedProgressBar());
          break;
        }
        yield delay(2000);
      }
      yield put(addProgressLog({ log: 'Импорт успешно завершен' }));
      yield put(importVehiclesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(importVehiclesFailed());
      yield handleImportFailure(data?.message);
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(importVehiclesFailed());
    yield handleImportFailure(e);
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}

const renderLog = items => {
  const errors = items?.errors || [];
  const errorMessages = errors.map(e => {
    const message = e.message || 'Ошибка без сообщения';
    const timestamp = e.created_at ? `[${dateTimeStringFormatter(e.created_at)}]` : '';
    return `${timestamp} ${message}`;
  });
  return errorMessages.map(msg => `<span>${msg}</span><br/>`);
};

function* handleImportFailure(error) {
  const time = moment().format('HH:mm:ss');
  yield put(addProgressLog({ log: `<span style="color: red">${time} - Ошибка импорта: ${error || 'Ошибка без сообщения'}</span>`, withOutTime: true }));
  yield put(stoppedProgressBar());
  yield put(setProgressList({ progressPercent: 100 }));
}
